<template>
  <div class="ndata" >
<!--    <el-header>-->
      <div class="ndata-head">
        <div class="header_left">
          <img v-if="websit && websit.siteLogo" :src="websit.siteLogo" style="width:40px;vertical-align: middle">
          <span v-if="websit && websit.siteName" style="font-weight: 400;font-size: 1rem">{{websit.siteName}}</span>
        </div>
        <div class="header_right">
          <!--<img src="/static/img/courseone.fb129d5.png" style="width:30px;height: 30px;border-radius: 50%;margin-right: 10px">-->
          <span v-if="userInfo" class="header_but"> {{userInfo.realName}}</span>
          <span v-if="userInfo" class="header_but" style="margin-left: 20px;color: #0F63E0" @click="signOut">退出</span>
          <span v-if="!userInfo" class="header_but"  @click="signIn">学员端登录</span>
          <el-divider direction="vertical"/>
          <span class="header_but" @click="signInAdmin">管理端登录</span>
        </div>
        <ul class="header_nav">
            <li  v-if="isMobile==null" class="header_nav_item nav_opacity"   :class="{
                header_nav_item_active: !activeIndex
              }" @click="toUrl()">
              <span>首页</span>
            </li>
          <li
            v-if="isMobile==null"
            class="header_nav_item nav_opacity"
            v-for="(item,i) in columnTreeList"
            :key="i"
            :class="{
                header_nav_item_active: activeIndex === item.id
              }"
            @click="toUrl(item)"
          >
        <span>
          {{ item.columnName }}
        </span>
          </li>
        </ul>
        <div v-if="isMobile!=null"  class="menu" v-clickoutside="closeBox" >
          <ul  @click="getShow">
            <li :class="isShow===false?'el-icon-arrow-down':'el-icon-notebook-2'" style="margin: 10% 0"></li>
            <li  :style="{'display':isShow?'none':'block'}" :class="{
                header_nav_item_active: activeIndex === ''
              }" @click="toUrl()"><span>首页</span></li>
            <li
              :style="{'display':isShow?'none':'block'}"
              v-for="(item,i) in columnTreeList"
              :key="i"
              :class="{
                header_nav_item_active: activeIndex === item.id
              }"
              @click="toUrl(item)"
            >
            <span>
              {{ item.columnName }}
            </span>
            </li>
            <li  :style="{'display':isShow?'none':'block'}" style="margin: 30% 0"></li>
          </ul>
        </div>

<!--      <el-divider class="home-hr"/>-->
      </div>
    <div style="height: 43px; width: 100%;background: #F5F5F5;border: 1px solid #F5F5F5;"></div>
      <div class="main-core-content">
        <slot></slot>
      </div>
    <div class="ndata-footer">
      <Footer :top-height="20"></Footer>
    </div>
<!--    </el-header>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import apis from '@/apis/student/home'
import Clickoutside from 'element-ui/src/utils/clickoutside'
// import {getWebsitBanner} from '../utils/auth'
// 监听点击事件

export default {
  directives: { Clickoutside },
  data () {
    return {
      form: {
        title: ''
      },
      title: '',
      columnTree: [],
      dictList: [],
      isShow: true,
      innerHeight: 0,
      isMobile: null,
      userInfo: null
    }
  },
  computed: {
    ...mapGetters(['columnTreeList', 'activeIndex', 'user', 'websitBanner', 'websitLogo', 'websit'])
  },
  mounted () {
    // this.websitBanner = getWebsitBanner()
    this.innerHeight = parseInt(window.innerHeight) * 0.32
    this.ismobile()
    // window.addEventListener('scroll', this.showHeader)
  },
  created () {
    console.log(this.activeIndex)
    if (this.user) {
      this.userInfo = this.user
    } else {
      let keyValue = localStorage.getItem('user')
      if (keyValue !== null && keyValue !== undefined && keyValue.indexOf('[object Object]') <= -1) {
        this.userInfo = JSON.parse(keyValue)
      } else {
        this.userInfo = null
      }
    }
  },
  destroyed () {
    // window.removeEventListener('scroll', this.showHeader)
  },
  methods: {
    ismobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.isMobile = flag
    },
    closeBox () {
      if (!this.isShow) {
        this.getShow()
      }
    },
    getShow () {
      this.isShow = !this.isShow
    },
    showHeader () {
      // 获取当前滚动条向下滚动的距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let nav = document.querySelector('.header_nav')
      // 当页面滚动到高度300px处时，导航浮动
      if (scrollTop > 380) {
        nav.classList.add('fixedNav')
      } else {
        nav.classList.remove('fixedNav')
      }
    },
    registerMessage () {
      this.$router.push({
        path: '/generalregister'
      })
    },
    signIn () {
      this.$router.push({
        path: '/login'
      })
    },
    signInAdmin () {
      window.open('https://competition.tpr.ndlink.cn')//其他部署
      // window.open('https://casuvuadmin.tpr.ndlink.cn')//乌鲁木齐职业大学
      // window.open('https://gcpadmin.tpr.ndlink.cn')// 广州城市职业学院
      // window.open('http://169.254.101.248:9091')//菏泽
    },
    signOut () {
      apis.logout().then(res => {
        const {code, msg} = res
        if (code === 0) {
          this.$store.commit('SET_USER')
          this.$cookie.delete('token')
          this.$store.commit('SET_ACTIVEINDEX', '')
          localStorage.removeItem('user')
          localStorage.removeItem('accessToken')
          this.userInfo = null
          this.$router.push({
            path: '/'
          })
          this.$message.success(msg)
        } else {
          this.$message.warning(msg)
        }
      })
    },
    toUrl (item) {
      if (item) {
        if (item.isExtralinks === 1) {
          if (item.openWith === 2) {
            window.open(item.extralinksUrl)
          } else {
            window.location.href = item.extralinksUrl
          }
        } else if (item.isExtralinks === 0) {
          this.$store.commit('SET_COLUMNITEM', item)
          this.$store.commit('SET_COLUMNITEM_PARENT', item)
          this.$store.commit('SET_ACTIVEINDEX', item.id)
          this.$router.push({
            path: '/' + item.columnCode,
            query: {columnId: item.id, activeChildrenIndex: item.id},
            name: item.columnCode
          })
          console.log(this.activeIndex)
        } else {
          this.$store.commit('SET_COLUMNITEM', item)
          this.$store.commit('SET_COLUMNITEM_PARENT', item)
          this.$store.commit('SET_ACTIVEINDEX', item.id)
          this.$router.push({path: '/secondlist', query: {activeChildrenIndex: item.id}})
        }
      } else {
        this.$store.commit('SET_COLUMNITEM', [])
        this.$store.commit('SET_COLUMNITEM_PARENT', [])
        this.$store.commit('SET_ACTIVEINDEX', '')
        this.$router.push({
          path: '/'
        })
      }
    },
    homeSearch () {
      localStorage.setItem('keywords', this.form.title)
      this.form.title = ''
      this.$store.commit('SET_ACTIVEINDEX')
      this.$router.push({
        path: '/sitesearch'
      })
    },
    handlePersonal () {
      this.$router.push({
        path: '/personalcenter'
      })
    },
    handleEditPass () {
      this.$router.push({
        path: '/editpass'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import url('../assets/css/bass.css');
  .fixedNav{
    position: fixed!important;
    top: -21px!important;
    z-index: 999;
    width: 99%;
  }
  @media (max-width: 950px) {
    .fixedNav{
      width: 100%;
    }
  }
  .header_nav{
    display: flex;
    justify-content: center;
    position: absolute;
    top: -20px;
    left: 30%;
    font-size: 1rem;
    font-weight: normal;
    color: #333333;
    line-height: 22px;
    background-size: 100% 100%;
    //padding: 0;
    li{
      list-style: none;
      text-align: center;
      line-height: 30px;
      padding: 10px;
      height: 29px;
      width: 80px;
      margin: 0 15px;
    }
  }
  @media (max-width: 950px) {
    .header_nav{
      display: block;
      min-height: 20px;
      z-index: 9;
    }

  }
  @media (max-width: 950px) {
    .header_nav{
      li{
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .header_nav_item{
    padding: 1rem 1.5rem;
    cursor: pointer;
    :hover{
      font-weight: bold;
    }
  }
  .header_nav_item_active{
    color: #0F63E0;
    font-weight: bold;
    background-size: 100% 100%;
    background: #DFECFF;
    span{
      padding-bottom: 5px;
      border-bottom: 3px  solid #0F63E0;
    }
  }
  @media (max-width: 950px) {
    .header_nav_item_active{
      color: #0F63E0!important;
      font-weight: bold;
      background-size: 100% 100%;
      border-radius: 5px 5px 0px 0px;
    }
  }
  .home-hr{
    margin-top: -2px;
    border: solid 2px #285ADC;
    background-color: #285ADC;
    opacity: 1;
    width: 99.7%;
  }
  .search-button{
    width: 55px;
    height: 40px;
    background: #285ADC;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    padding: 0px;
  }
  .demo-form-inline{
    display: -webkit-box;
    display: -ms-flexbox;
    position: relative;
    width: 274px;
    height: 90px;
    left: 75rem;
}
.el-form--inline .el-form-item{
  margin-right: 0px;
}
.el-input__inner{
  order-radius: 0px;
}
.header_left{
  width: 32%;
  height: 100%;
  text-align: center;
  padding-top: 10px;
}
  @media (max-width: 950px) {
    .header_left{
      width: 100%;
      height: 100%;
      text-align: left;
    }
  }
.header_logo{
  font-size: 30px;
  color: #163F8E;
  font-weight: 900;
  margin-top: 55px;
  width: 50%;
  margin-left: 19%;
  img{
    width: 100%;
  }
}
.header_logo_eg{
  font-size: 18px;
  color: #163F8E;
  font-weight: 600;
}
.main-core-content{
  width: 80%;
  min-height: 750px;
  margin: 10px auto 0 auto;
}
@media (max-width: 950px) {
  .main-core-content{
    width: 100%;
    margin: 0;
  }
}
.header_right{
  display: flex;
  position: absolute;
  top: 10px;
  right: 30px;
  span{
    cursor: pointer;
  }
}

.header_but{
  font-size: 1rem;
  font-weight: normal;
  color: #000;
  border: none;
  &:hover{
    color: #0F63E0;
  }
}
  @media (max-width: 950px) {
    .header_right{
      top: 9px;
      font-size: 12px;
      right: 10px;
    }
    .header_but{
      font-size: 10px!important;
    }
    /deep/.el-divider--vertical{
      margin: 0 2px;
    }
  }
/deep/.divider{
  background-color: #285ADC !important;
  margin-bottom: 2px;
  width: 2px;
}
.search{
  position: absolute;
  float: right;
  bottom: 0.5rem;
  right: 3rem;
  .el-input{
    width: 11rem;
  }
}
.ndata{
  position: relative;
  width: 100%;
}
.ndata-head{
  //position: relative;
  position: fixed;
  height: 45px;
  width: 100%;
  z-index: 1999;
  background: #F5F5F5;
}
  /deep/ .el-header{
    padding: 0px;
  }
  @media (max-width: 950px) {
    /* 初始状态下的样式 */
    .menu ul {
      list-style-type: none;
      padding: 0;
      top: 48px;
      right: 5px;
      position: fixed;
      z-index: 999;
      text-align: center;
      /*background:#4444445e;*/
      background:#ffffffd9;
      min-width: 80px;
      min-height: 30px;
      margin-right: 5px;
      line-height: 30px;
      border-radius: 50px;
      box-shadow: 1px 1px 3px 1px rgba(51,51,51,0.3);
    }

    .menu li {
      display: block;
      margin-bottom: 5px;
    }

    .menu span {
      display: block;
      padding: 5px 10px;
      text-decoration: none;
    }

    /* 折叠状态下的样式 */
    .menu li ul {
      display: none;
    }

    /* 悬浮状态下的样式 */
    .menu li:hover ul {
      display: block;
      position: absolute;
      left: 100%;
      top: 0;
    }

    .menu li:hover ul li {
      display: block;
      margin-left: 0;
    }
  }
  .ndata-footer{
    bottom: 0;
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu-layout.vue